import { Component, effect, Input } from '@angular/core';
import { Language } from '../../../core/services/language';

@Component({
  selector: 'app-language-toggle',
  templateUrl: './language-toggle.html',
  styleUrl: './language-toggle.css'
})
export class LanguageToggle {
  currentLang: 'en' | 'ar' = 'en';
  @Input() extraClass?: string = '';

  constructor(private langService: Language) {

    // Reactively track language changes using effect
    effect(() => {
      this.currentLang = this.langService.language();
    });
  }

  setLang(lang: 'en' | 'ar') {
    this.langService.setLanguage(lang);
  }


  toggleLang() {
    this.langService.toggleLanguage();
  }
}
